<template>
    <div class="no-pr-container">
        <div class="no-pr-icon-wrapper">
            <Svg :src="require('@/assets/icons/no-pr-icon.svg')" alt="no-pr-icon"></Svg>
        </div>
        <p class="no-pr-text">{{ title }}</p>
        <p class="no-pr-sub-text">{{ subTitle }}</p>
        <button v-if="stage == 'DRAFT' && !filter" @click="handleCreateClick" class="new-pr-container">
            <Svg :src="require('@/assets/icons/create-icon.svg')" alt="create"></Svg>
            <span>Create</span>
        </button>

    </div>
</template>
<script>
export default {
    props: {
        title: String,
        subTitle: String,
        stage: String,
        filter: Boolean,
    },
    methods: {
        handleCreateClick() {
            this.$emit('create-dialog');
        }
    },
   
}

</script>
<style scoped>
.no-pr-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    gap: 0.5rem;
}

.no-pr-text {
    font-size: var(--header-font-size);
    font-weight: 600;
}

.no-pr-sub-text {
    font-size: var(--normal-font-size);
    color: var(--dark-grey-color);
}

.new-pr-container {
    display: flex;
    background: black;
    flex-direction: row;
    color: var(--secondary-font-color);
    border-radius: 8px;
    align-items: center;
    gap: 8px;
    padding: 0.8rem 1.8rem;
    font-family: 'OverpassMono';

}
</style>